import * as React from 'react';
import { SVGProps } from 'react';

const SvgForHips = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.475 6H7v30h25V6h-4.373"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M28.25 9.25h-17.5v-5.5h17.5v5.5Z"
    />
    <path
      fill="currentColor"
      d="M14.113 7.404a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804Zm11.147 0a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804ZM22.78 24.32a1.85 1.85 0 0 0-1.85-1.849c-1.022 0-1.964.838-1.85 1.85.018.157.053.312.103.462-.734.728-1.363 1.116-1.804 1.316l-.06-.12a1.077 1.077 0 1 0-1.909.998c.007.013.701 1.344 1.146 2.49 1.03 2.645 1.49 5.794 1.497 5.842a1.077 1.077 0 1 0 2.132-.305c-.013-.087-.21-1.448-.641-3.168a13.517 13.517 0 0 1-.195-2.787 4.427 4.427 0 0 1 1.299-2.909c.092.017.185.024.279.022a1.868 1.868 0 0 0 1.853-1.841Z"
    />
    <path
      fill="currentColor"
      d="M29.583 28.064a4.426 4.426 0 0 1-3.877 1.013c-1.565-.323-1.508-1.435-1.494-1.787l-2-.487c-.103 1.077.336 3.35 2.735 4.246.431.16.888.241 1.347.24 2.239 0 3.23-.838 3.329-.924l-.04-2.3Zm-.097-3.45s-1.066-.389-1.897-.754c-.832-.365-2.612-1.727-2.605-5.053.008-3.183.214-4.112-1.794-6.22-.838-.885-6.048-2.992-8.542 2.152-2.494 5.145 3.34 9.093 3.34 9.093l.05-.149c.17-.468.822-1.889 2.443-2.014 1.754-.137 2.5.837 2.807 1.305.663 1.013.177 2.18-.107 2.7l-.166.275 2.12.624a9.976 9.976 0 0 0 2.195.388l2.273.144-.117-2.491ZM20.6 12.564c-.564.122-1.118.287-1.656.496-1.063.409-1.958 1.047-2.597 2.004-.323.474-.599.98-.824 1.507a.176.176 0 0 1-.341-.079 4.958 4.958 0 0 1 1.829-3.251 5.563 5.563 0 0 1 3.575-1.04.183.183 0 0 1 .014.364Z"
    />
    <path
      fill={props.fill}
      d="M6.28 36.875V33.56l23.328-.016 3.338 3.331H6.28Z"
    />
  </svg>
);

export default SvgForHips;
